import React from 'react';

function LinkExpired() {
  return (
    <div style={{
      backgroundColor: '#f8f9fa',
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '10px'
    }}>
      <div style={{
        width: '100%',
        maxWidth: '800px',
        margin: '0 auto',
        padding: '20px'
      }}>
        <div style={{
          backgroundColor: 'white',
          borderRadius: '10px',
          padding: '40px 30px',
          boxShadow: '0 5px 15px rgba(0,0,0,0.1)',
          textAlign: 'center',
          borderLeft: '5px solid #27568B',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <div style={{
            position: 'absolute',
            top: '0',
            left: '0',
            width: '100%',
            height: '5px',
            background: '#27568B',
          }}></div>
          
          <h3 style={{
            color: '#27568B',
            marginBottom: '20px',
            fontWeight: '600',
            fontSize: '1.75rem'
          }}>  This link is expired.</h3>
          
          <div style={{
            fontSize: '1.1rem',
            lineHeight: '1.6',
            color: '#555',
            marginBottom: '25px'
          }}>
            <p>The link you're trying to access has expired or is no longer valid.</p>
          </div>
          
          <div style={{
            backgroundColor: '#F1F8E9',
            padding: '15px',
            borderRadius: '8px',
            margin: '20px 0',
            borderLeft: '3px solid #27568B'
          }}>
            <p style={{
              margin: '0',
              color: '#721c24',
              fontWeight: '500'
            }}>
              Please contact the HR department if you believe this is an error or need a new link.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LinkExpired;